let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

/* Elly cart milestone — live updater (runs globally; no-ops unless #ecm present) */
(function () {
  var lastFree = null;
  function celebrate() {
    var root = document.getElementById('ecm');
    if (!root) return;
    var r = root.getBoundingClientRect();
    var cx = r.left + r.width / 2, cy = r.top + 34;
    var colors = ['#B5613C', '#D29A6E', '#2E4031', '#C9A24B', '#F6F2EA', '#A37C5C'];
    var wrap = document.createElement('div');
    wrap.style.cssText = 'position:fixed;left:0;top:0;z-index:2147482000;pointer-events:none;';
    document.body.appendChild(wrap);
    for (var i = 0; i < 46; i++) {
      var p = document.createElement('div');
      var sz = 6 + Math.random() * 7;
      var ang = Math.random() * Math.PI * 2, dist = 50 + Math.random() * 150;
      var dx = Math.cos(ang) * dist, dy = Math.sin(ang) * dist - 50;
      p.style.cssText = 'position:fixed;left:' + cx + 'px;top:' + cy + 'px;width:' + sz + 'px;height:' + (sz * 0.62) + 'px;background:' + colors[i % colors.length] + ';border-radius:1px;transform:translate(-50%,-50%);will-change:transform,opacity;box-shadow:0 1px 2px rgba(0,0,0,.08);';
      wrap.appendChild(p);
      (function (el, ddx, ddy) {
        var start = null, dur = 900 + Math.random() * 600, rot = Math.random() * 720 - 360;
        function step(ts) {
          if (!start) start = ts;
          var t = (ts - start) / dur;
          if (t >= 1) { el.remove(); return; }
          var ease = 1 - Math.pow(1 - t, 2);
          var x = ddx * ease, y = ddy * ease + 260 * t * t;
          el.style.transform = 'translate(-50%,-50%) translate(' + x + 'px,' + y + 'px) rotate(' + (rot * t) + 'deg)';
          el.style.opacity = (1 - t * t);
          requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      })(p, dx, dy);
    }
    setTimeout(function () { if (wrap.parentNode) wrap.remove(); }, 2200);
    var msg = document.getElementById('ecm-msg');
    if (msg) { msg.style.transition = 'transform .3s cubic-bezier(.34,1.56,.64,1)'; msg.style.transform = 'scale(1.14)'; setTimeout(function () { msg.style.transform = 'scale(1)'; }, 320); }
  }
  function money(v) {
    return 'Rs. ' + v.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function biggest(t) {
    if (!t) return 0;
    var m = t.replace(/,/g, '').match(/\d+(?:\.\d+)?/g);
    if (!m) return 0;
    var mx = 0;
    m.forEach(function (s) { var v = parseFloat(s); if (v > mx) mx = v; });
    return mx;
  }
  function compute() {
    var all = [].slice.call(document.querySelectorAll('.cart-item'));
    var vis = all.filter(function (r) { return r.offsetParent !== null; });
    var rows = vis.length ? vis : all;
    var seen = {}, n = 0, cheapest = null;
    rows.forEach(function (r) {
      var qi = r.querySelector('.quantity__input');
      var k = qi ? (qi.getAttribute('data-quantity-variant-id') || qi.id || qi.name || '') : '';
      if (k) { if (seen[k]) return; seen[k] = 1; }
      var q = qi ? (parseInt(qi.value, 10) || 0) : 0;
      if (q <= 0) return; n += q;
      var pw = r.querySelector('.cart-item__price-wrapper') || r.querySelector('.cart-item__totals');
      var lt = biggest(pw ? pw.textContent : '');
      var unit = q > 0 ? lt / q : lt;
      if (unit > 0 && (cheapest === null || unit < cheapest)) cheapest = unit;
    });
    return { n: n, mu: cheapest || 0 };
  }
  function apply() {
    var root = document.getElementById('ecm');
    if (!root) return;
    var msg = document.getElementById('ecm-msg');
    var fill = document.getElementById('ecm-fill');
    if (!msg || !fill) return;
    var cells = [].slice.call(root.querySelectorAll('[data-th]'));
    var c = compute(), n = c.n;
    if (n <= 0) { root.style.display = 'none'; return; }
    root.style.display = '';
    var free = Math.floor(n / 4), saving = free * c.mu;
    var p = n >= 4 ? 100 : (n === 3 ? 75 : (n === 2 ? 50 : 0));
    fill.style.width = (66.666 * p / 100) + '%';
    var html, col = '#A24E2C';
    if (n >= 4) { col = '#3B6D11'; html = '✓ You’re saving ' + money(saving) + ' on this order'; }
    else if (n === 3) { html = 'Just 1 more — your 4th item is FREE'; }
    else if (n === 2) { html = '15% off unlocked · add 2 more for a FREE item'; }
    else { html = '10% off unlocked · add 1 more for 15% off'; }
    msg.style.color = col; msg.innerHTML = html;
    if (lastFree !== null && free > lastFree) celebrate();
    lastFree = free;
    cells.forEach(function (cl) {
      var th = parseInt(cl.getAttribute('data-th'), 10), on = n >= th;
      var circ = cl.querySelector('.ecm-c'), lab = cl.querySelector('.ecm-l');
      if (!circ || !lab) return;
      if (on) { circ.style.background = '#B5613C'; circ.style.color = '#fff'; circ.style.border = 'none'; lab.style.color = '#2E4031'; }
      else { circ.style.background = '#F6F2EA'; circ.style.color = 'transparent'; circ.style.border = '1px solid #D8C7AC'; lab.style.color = '#9a9388'; }
    });
  }
  function boot() {
    apply();
    setInterval(apply, 700);
    document.addEventListener('change', function (e) { if (e.target && /quantity|updates/i.test(e.target.name || '')) { apply(); setTimeout(apply, 300); } });
    document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('.quantity__button,cart-remove-button,.cart-remove-button')) { setTimeout(apply, 350); requestAnimationFrame(apply); } });
    document.addEventListener('visibilitychange', function () { if (!document.hidden) apply(); });
    try { subscribe('cart-update', function () { apply(); setTimeout(apply, 200); }); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* Elly: reset stuck drawers/overlays on back-forward cache restore */
(function () {
  function resetOverlays() {
    var cd = document.querySelector('cart-drawer');
    if (cd) { try { if (typeof cd.close === 'function') cd.close(); } catch (e) {} cd.classList.remove('active', 'animate'); }
    var mm = document.querySelector('menu-drawer, .menu-drawer');
    var dds = document.querySelectorAll('details[open]');
    for (var i = 0; i < dds.length; i++) {
      var d = dds[i];
      if (d.querySelector('.menu-drawer, cart-drawer, .cart-drawer, #Details-menu-drawer-container') || (d.className || '').indexOf('menu-drawer') > -1) {
        d.removeAttribute('open');
      }
    }
    var bcl = document.body.classList;
    bcl.remove('overflow-hidden', 'overflow-hidden-mobile', 'overflow-hidden-tablet');
    document.documentElement.classList.remove('overflow-hidden');
    document.body.style.removeProperty('overflow');
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) resetOverlays(); });
  window.addEventListener('popstate', function () { setTimeout(resetOverlays, 0); });
})();
